module.exports = __webpack_public_path__ + "media/fonts/icomoon-42412d98.ttf";